export default __webpack_public_path__ + "static/0-cd09e6380653434dc2ad598020faeacf.png";